import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  DataForeignCitizen,
  IDCardVerifiedTypes,
  IdentityReport,
  MIReportData,
} from '../../../../core/types/identity-reports';
import { Utils } from '../../../../core/utils/utils';

@Component({
  selector: 'itfg-mi-card',
  templateUrl: './mi-card.component.html',
  styleUrls: ['./mi-card.component.scss'],
  standalone: false,
})
export class MiCardComponent implements OnChanges {

  @Input() isReport: boolean;
  @Input() isClientDataMatch: boolean;
  @Input() civilId: number;
  @Input() idCardNumber: number;
  @Input() reportData: IdentityReport<MIReportData>;
  @Input() clientReportData: MIReportData;
  @Input() selectedIdCardFront: any;

  @Output() scrollToClientMapper = new EventEmitter<void>();
  @Output() idCardVerificationHovered = new EventEmitter<boolean>();

  readonly IDCardVerifiedType = IDCardVerifiedTypes;

  civilIdAge: number;
  civilIdGender: string;
  dataForeignCitizen: DataForeignCitizen;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.civilId) {
      this.civilIdGender = Utils.getClientGenderFromCivilId(this.civilId);
      this.civilIdAge = Utils.calculateClientAgeFromCivilId(this.civilId);
    }
    if (this.clientReportData) {
      this._parseClientData(this.clientReportData);
    }
  }

  scrollToClient(): void { this.scrollToClientMapper.emit(); }
  mouseEnter(): void { this.idCardVerificationHovered.emit(true); }
  mouseLeave(): void { this.idCardVerificationHovered.emit(false); }

  // ── Private ────────────────────────────────────────────────────────

  private _parseClientData(d: MIReportData): void {
    // Foreign citizen reference
    this.dataForeignCitizen = d.DataForeignCitizen ?? ({} as DataForeignCitizen);

    // Names — prefer Bulgarian fields, fall back to foreign citizen names
    if (typeof (d.PersonNames as any) === 'string') d.PersonNames = {};
    d.PersonNames ??= {};
    d.PersonNames.FirstName = this._cap(d.PersonNames.FirstName || this.dataForeignCitizen?.Names?.FirstName);
    d.PersonNames.Surname = this._cap(d.PersonNames.Surname || this.dataForeignCitizen?.Names?.Surname);
    d.PersonNames.FamilyName = this._cap(d.PersonNames.FamilyName || this.dataForeignCitizen?.Names?.FamilyName);

    // Settlement — keep only the part before the first comma
    if (d.PermanentAddress?.SettlementName) {
      d.PermanentAddress.SettlementName = d.PermanentAddress.SettlementName.split(',')[0].trim();
    }

    // Issuer — first segment only
    d.IssuerName = d.IssuerName?.split('/')[0] ?? '';

    // Issue date — date portion only
    d.IssueDate = d.IssueDate?.substring(0, 10) ?? '';

    // Address — built from the fields the type actually has
    const pa = d.PermanentAddress;
    d.address = [
      pa?.DistrictName,
      pa?.MunicipalityName,
      pa?.SettlementName,
    ].filter(Boolean).join(', ');
  }

  /** Capitalise each hyphen-separated segment. */
  private _cap(value: string | undefined): string {
    if (!value) return '';
    return value
      .split('-')
      .map(seg => seg.charAt(0).toUpperCase() + seg.slice(1).toLowerCase())
      .join('-');
  }
}